export { default as GDMTableHead } from './GDMTableHead';

export type { GDMTableHeadComponent, GDMTableHeadProps } from './GDMTableHead.type';
